import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'group flex size-[40px] -rotate-90 cursor-pointer items-center justify-center transition-colors duration-150 md:size-[50px]',
    icon: 'flex size-6 items-center justify-center',
    arrow: 'group-hover:[&>path]:stroke-icon-hover'
  },
  variants: {
    disabled: {
      true: 'hidden'
    },
    left: {
      true: 'rotate-90 justify-center'
    },
    theme: {
      default: {
        base: 'text-text-main'
      },
      predator: {
        base: 'text-white',
        arrow: '[&>path]:stroke-white'
      }
    }
  },
  defaultVariants: {
    theme: 'default'
  }
});
